var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubContractorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.049,
    height: 16.958,
    viewBox: "0 0 13.049 16.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sub-contractor-icon",
    transform: "translate(-37.926 -280.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.387,16.958a.663.663,0,0,1-.662-.662,4.708,4.708,0,0,0-4.7-4.7H6.028a4.709,4.709,0,0,0-4.7,4.7A.662.662,0,0,1,0,16.3a6.035,6.035,0,0,1,6.028-6.027h.994A6.034,6.034,0,0,1,13.049,16.3.663.663,0,0,1,12.387,16.958ZM6.458,8.943A4.472,4.472,0,1,1,10.93,4.472,4.476,4.476,0,0,1,6.458,8.943Zm0-7.619A3.146,3.146,0,1,0,9.6,4.472,3.15,3.15,0,0,0,6.458,1.325Z",
    transform: "translate(37.926 280.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3.345,4.5a.658.658,0,0,1-.332-.09L.33,2.859A.663.663,0,0,1,.1,1.94L1.091.317a.662.662,0,0,1,1.13.692L1.581,2.053,3.349,3.079,5.162,2.052,4.508,1.017A.662.662,0,1,1,5.627.309L6.654,1.932a.662.662,0,0,1-.233.93L3.671,4.419a.665.665,0,0,1-.326.086Z",
    transform: "translate(41.072 292.798)",
    fill: "#eb742e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubContractorIcon);
export default __webpack_public_path__ + "static/media/sub-contractor-icon.693232d3397964d0ef98c13a79518682.svg";
export { ForwardRef as ReactComponent };